export const MATCH_STATUS = {
  SCHEDULED: 'SCHEDULED',
  TIMED: 'TIMED',
  IN_PLAY: 'IN_PLAY',
  PAUSED: 'PAUSED',
  EXTRA_TIME: 'EXTRA_TIME',
  PENALTY_SHOOTOUT: 'PENALTY_SHOOTOUT',
  FINISHED: 'FINISHED',
  SUSPENDED: 'SUSPENDED',
  POSTPONED: 'POSTPONED',
  CANCELLED: 'CANCELLED',
  AWARDED: 'AWARDED',
} as const;

export type MatchStatus = typeof MATCH_STATUS[keyof typeof MATCH_STATUS];

export const MATCH_STATUS_GROUPS = {
  PRE_MATCH: [MATCH_STATUS.SCHEDULED, MATCH_STATUS.TIMED] as MatchStatus[],
  LIVE: [MATCH_STATUS.IN_PLAY, MATCH_STATUS.PAUSED, MATCH_STATUS.EXTRA_TIME, MATCH_STATUS.PENALTY_SHOOTOUT] as MatchStatus[],
  COMPLETED: [MATCH_STATUS.FINISHED, MATCH_STATUS.AWARDED] as MatchStatus[],
  DISRUPTED: [MATCH_STATUS.SUSPENDED, MATCH_STATUS.POSTPONED, MATCH_STATUS.CANCELLED] as MatchStatus[],
};

export const isPreMatch = (s: string) => MATCH_STATUS_GROUPS.PRE_MATCH.includes(s as MatchStatus);
export const isLive = (s: string) => MATCH_STATUS_GROUPS.LIVE.includes(s as MatchStatus);
export const isCompleted = (s: string) => MATCH_STATUS_GROUPS.COMPLETED.includes(s as MatchStatus);
export const isDisrupted = (s: string) => MATCH_STATUS_GROUPS.DISRUPTED.includes(s as MatchStatus);

export const STATUS_CSS_CLASS: Record<string, string> = {
  SCHEDULED: 'scheduled',
  TIMED: 'scheduled',
  IN_PLAY: 'live',
  PAUSED: 'live',
  EXTRA_TIME: 'live',
  PENALTY_SHOOTOUT: 'live',
  FINISHED: 'finished',
  AWARDED: 'finished',
  SUSPENDED: 'suspended',
  POSTPONED: 'postponed',
  CANCELLED: 'cancelled',
};

export const STATUS_DISPLAY_TEXT: Record<string, string> = {
  SCHEDULED: 'Запланирован',
  TIMED: 'Запланирован',
  IN_PLAY: 'Live',
  PAUSED: 'Перерыв',
  EXTRA_TIME: 'Доп. время',
  PENALTY_SHOOTOUT: 'Пенальти',
  FINISHED: 'Завершён',
  AWARDED: 'Присуждён',
  SUSPENDED: 'Приостановлен',
  POSTPONED: 'Перенесён',
  CANCELLED: 'Отменён',
};

export const STATUS_BADGE_TEXT: Record<string, string> = {
  SCHEDULED: '',
  TIMED: '',
  IN_PLAY: 'LIVE',
  PAUSED: 'HT',
  EXTRA_TIME: 'ET',
  PENALTY_SHOOTOUT: 'PEN',
  FINISHED: 'FT',
  AWARDED: 'AWD',
  SUSPENDED: 'SUSP',
  POSTPONED: 'PP',
  CANCELLED: 'CAN',
};
